import { Box, Button, Typography } from "@mui/material";
import { ReactNode } from "react";

type ChatEmptyStateProps = {
  icon: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  loading?: boolean;
};

export const ChatEmptyState = ({
  icon,
  title,
  description,
  action,
  loading = false,
}: ChatEmptyStateProps) => (
  <Box
    sx={{
      minHeight: 220,
      height: "100%",
      px: 3,
      py: 5,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      gap: 1,
    }}
  >
    <Box
      sx={{
        width: 64,
        height: 64,
        borderRadius: "50%",
        display: "grid",
        placeItems: "center",
        color: "#d8b4fe",
        bgcolor: "rgba(138,0,204,0.16)",
        border: "1px solid rgba(168,85,247,0.28)",
        mb: 0.75,
      }}
    >
      {loading ? (
        <Box sx={{ display: "flex", gap: 0.55 }}>
          {[0, 1, 2].map((dot) => (
            <Box
              key={dot}
              sx={{
                width: 7,
                height: 7,
                borderRadius: "50%",
                bgcolor: "#c084fc",
                animation: "chatEmptyDot 1.1s ease-in-out infinite",
                animationDelay: `${dot * 140}ms`,
                "@keyframes chatEmptyDot": {
                  "0%, 60%, 100%": { transform: "translateY(0)", opacity: 0.45 },
                  "30%": { transform: "translateY(-5px)", opacity: 1 },
                },
              }}
            />
          ))}
        </Box>
      ) : icon}
    </Box>
    <Typography variant="subtitle2" fontWeight={800}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 300 }}>
        {description}
      </Typography>
    )}
    {action}
  </Box>
);

export const ChatEmptyAction = ({ children, onClick }: { children: ReactNode; onClick: () => void }) => (
  <Button size="small" onClick={onClick} sx={{ mt: 1, borderRadius: 999, fontWeight: 800 }}>
    {children}
  </Button>
);
